// src/vo/hoiXoa.js

// ============================================================
// 🗑️ HỎI TRƯỚC KHI XÓA
// ------------------------------------------------------------
// Trước Đợt N1 có MƯỜI HAI chỗ gọi `window.confirm`, câu chữ mỗi nơi một kiểu:
//
//     "Xóa việc "Mua vé"?"                   (có tên, ngắn)
//     "Xóa hóa đơn này?"                     (không tên)
//     "Bạn có chắc muốn xóa sự kiện này?"    (dài, có "bạn có chắc")
//
// Cùng một hành động mà ba giọng khác nhau. Với người lớn tuổi, câu hỏi
// KHÔNG NÓI RÕ ĐANG XÓA CÁI GÌ là câu hỏi khó trả lời — "cái này" là cái nào?
//
// ⚠️ ĐỢT NÀY CỐ Ý CHƯA THAY window.confirm BẰNG HỘP THOẠI RIÊNG.
// Mục 9 tồn đọng có ghi "bỏ alert() ở các component" và window.confirm cùng
// họ với nó: hộp thoại của trình duyệt xấu, không theo cỡ chữ của app, và
// trên iPhone thì hiện ra giữa màn hình như thông báo hệ thống.
//
// Nhưng dựng hộp thoại riêng là việc khác hẳn — cần component hộp thoại,
// cần luồng bất đồng bộ, cần khóa nền, cần bẫy phím Escape. Nhét vào đợt
// "gom vỏ chung" là phình phạm vi.
//
// Cái đợt này làm được, và làm đúng: gom về MỘT chỗ. Khi nào dựng hộp thoại
// thật thì chỉ phải sửa ruột hàm này, không phải đi lục mười hai chỗ.
// ============================================================

/**
 * Hỏi trước khi xóa, câu chữ thống nhất cả app.
 *
 *     hoiXoa("việc", v.name)          → Xóa việc "Mua vé về Qui Nhơn"?
 *     hoiXoa("số điện thoại", d.ten)  → Xóa số điện thoại "Thợ nước Tài"?
 *     hoiXoa("bản tin tháng 9")       → Xóa bản tin tháng 9?
 *
 * @param {string} loai  đang xóa loại gì — viết thường, không viết hoa
 * @param {string} [ten] tên cụ thể của mục. Có thì luôn nên đưa vào.
 * @param {string} [themLoiCanhBao] câu cảnh báo hậu quả kèm theo, nếu có
 * @returns {boolean} người dùng có đồng ý xóa không
 */
export function hoiXoa(loai, ten, themLoiCanhBao) {
  const dong1 = ten ? `Xóa ${loai} "${ten}"?` : `Xóa ${loai}?`;
  const cauHoi = themLoiCanhBao ? `${dong1}\n\n${themLoiCanhBao}` : dong1;
  return window.confirm(cauHoi);
}
